<template>
<v-app class="main-content">
    <router-view></router-view>
</v-app>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style>
/* GLOBAL */
* {
    font-family: 'Manrope', sans-serif;
    letter-spacing: 0.03em;

}

.main-content {
    background-color: #47484a !important;
}

html {
    overflow: auto !important;
}

.download-template {
    text-decoration: none;
}

ul.v-breadcrumbs {
    background-color: #fff !important;
    border-bottom: solid 0.5px #eee;
}

.v-breadcrumbs__item {
    font-size: 14px !important;
}

.custom-tooltip {
    font-size: 12px;
}

/* th[role='columnheader'] {
    white-space: nowrap !important;
} */
</style>
